import router from "../../router";
import handleAppBarItems from "../../utils/handleAppBarItems";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    drawer: false,
    group: null,
    showGift: false,
    localItems: [],
    showShadow: true,
    appConfig: window.appConfig,
    instagramLink: window.instragramLink,
    menuVisible: false
  }),
  computed: {
    headerHidden() {
      return this.$store.state.ui.headerHidden;
    },
    showDestinies() {
      return this.appConfig == 'ebm';
    },
    logo(){
      return this.appConfig == 'avm' ? '/img/logo-ahora-vuelvo-mama.svg' : '/img/logo-ebm.svg';
    },
    ...mapGetters({
      destinationCards: "GET_DESTINATION_CARDS"
    })
  },
  watch: {
    group() {
      this.drawer = false;
    },
    $route(to,from){
      this.$eventHub.$emit("update-header", handleAppBarItems.call(this, router.currentRoute));
    }
  },
  created() {
    this.onCreated();
  },
  beforeDestroy() {
    this.$eventHub.$off("update-header");
  },
  methods: {
    onCreated(){
      this.localItems = this.items;
      this.$eventHub.$on("update-header", this.handleHeaderUpdate);
      this.$eventHub.$on("hide-appbar-shadow", this.hideShadow);
    },
    gohome() {
      window.location.href = '/';
      // this.$router.push({ name: "home-when" }).catch(() => {});
    },
    handleHeaderUpdate(value) {
      this.showGift = value.showGift;
      this.localItems = value.items;
    },
    hideShadow() {
      this.showShadow = false;
    },
    navigateToURL(item) {
      let url;
      const route = this.$router.resolve({ name: item.link });
      if (route.resolved.matched.length > 0) {
        if (this.$router.currentRoute.name !== "404") {
          this.$router.push({ name: item.link }).catch(() => {});
        } else {
          url = `${window.location.origin}${route.href}`;
          this.$router.push({ path: route.href }).catch(() => { });
        }
      } else {
        url = `${window.location.origin}/${item.link}`;
        this.$router.push({ path: `/${item.link}` }).catch(() => { });
      }
    },
    navigateToHelp() {
      this.$router.push({ name: 'help', params: { tab: 1 } });
    },
    navigateToContact() {
      window.location.href = '/contacto'
    },
    navigateTo(destination) {
      window.location.href = '/' + destination.link;
    }
  }
};
